import * as Immutable from 'immutable';
import moment from 'moment';
import { handleActions } from 'redux-actions';

import { DataActionType, DataStore, EventsProps } from './DataReducer.types';

// @ts-ignore
export const initialState: DataStore = Immutable.fromJS({
  results: Immutable.List(),
  eventsOpen: Immutable.List(),
  calendarEvents: Immutable.List(),
  isFetching: false,
  isFetchingOptions: false,
  defaultDate: new Date(),
  options: {
    languages: Immutable.Map(),
  },
});

const DataReducer = handleActions<any>(
  {
    REQUEST_EVENTS: (state: DataStore) => state.set('isFetching', true),

    RESPONSE_EVENTS_FAILURE: (state: DataStore) => state.set('isFetching', false),

    REQUEST_EVENTS_OPTIONS: (state: DataStore) => state.set('isFetchingOptions', true),

    CHANGE_DEFAULT_DATE: (state: DataStore, actions: DataActionType) => state.set('defaultDate', actions.payload),

    RESPONSE_EVENTS_OPTIONS: (state: DataStore, actions: DataActionType) => {
      if (actions.payload.data.language && actions.payload.data.language.choices && Array.isArray(actions.payload.data.language.choices)) {
        let languages = {};
        const options: any = actions.payload.data.language.choices;
        options.forEach((language: { value: string; label: string }) => {
          if (language.value !== '') {
            languages = { ...languages, [language.value]: language.label };
          }
        });

        return state.setIn(['options', 'languages'], Immutable.fromJS(languages)).set('isFetchingOptions', false);
      } else {
        return state.set('isFetchingOptions', false);
      }
    },

    RESPONSE_EVENTS_OPTIONS_FAILURE: (state: DataStore) => state.set('isFetchingOptions', false),

    RESPONSE_EVENTS: (state: DataStore, actions: DataActionType) =>
      state.merge(
        Immutable.fromJS({
          isFetching: false,
          results: Immutable.fromJS(
            actions.payload.data.results.sort((a: any, b: any) => {
              const first: any = moment(a.start).format('YYYYMMDD');
              const last: any = moment(b.start).format('YYYYMMDD');

              return first - last;
            })
          ),
          calendarEvents: Immutable.fromJS(
            actions.payload.data.results.map((eventData: EventsProps) =>
              Object.assign({}, eventData, { start: new Date(eventData.start), end: new Date(eventData.end) })
            )
          ),
        })
      ),
    AUTHENTICATION_LOGOUT: () => initialState,
    CLEAR_EVENTS: () => initialState,
  },
  initialState
);

export default DataReducer;
